export type DialLimitConfig = {
  enabled: boolean;
  daily_limit: number;
  reward_per_ad: number;
  /** 详情页「拨打电话」按钮是否显示剩余次数，如（3/10） */
  show_quota_on_button: boolean;
  /** 次数用尽时引导看广告的弹窗标题 */
  exhausted_modal_title: string;
  /** 次数用尽时引导看广告的弹窗内容；可用 {reward} 表示单次广告赠送次数 */
  exhausted_modal_body: string;
};

export const DIAL_LIMIT_DEFAULT_EXHAUSTED_TITLE = '今日拨号次数已用完';

export const DIAL_LIMIT_DEFAULT_EXHAUSTED_BODY =
  '完整观看激励视频，可额外获得{reward}次拨号机会（当日有效，可多次叠加）。';

export function defaultDialLimit(): DialLimitConfig {
  return {
    enabled: false,
    daily_limit: 3,
    reward_per_ad: 1,
    show_quota_on_button: true,
    exhausted_modal_title: DIAL_LIMIT_DEFAULT_EXHAUSTED_TITLE,
    exhausted_modal_body: DIAL_LIMIT_DEFAULT_EXHAUSTED_BODY,
  };
}

function trimDialText(raw: unknown, fallback: string, maxLen: number): string {
  const s = typeof raw === 'string' ? raw.trim() : '';
  const v = s || fallback;
  if (v.length <= maxLen) return v;
  return v.slice(0, maxLen);
}

export function normalizeDialLimit(raw: unknown): DialLimitConfig {
  const d = defaultDialLimit();
  if (!raw || typeof raw !== 'object') return d;
  const o = raw as Record<string, unknown>;
  let daily = Number(o.daily_limit);
  if (!Number.isFinite(daily)) daily = d.daily_limit;
  if (daily < 0) daily = 0;
  if (daily > 999) daily = 999;
  let reward = Number(o.reward_per_ad);
  if (!Number.isFinite(reward) || reward < 1) reward = d.reward_per_ad;
  if (reward > 99) reward = 99;
  return {
    enabled: !!o.enabled,
    daily_limit: Math.floor(daily),
    reward_per_ad: Math.floor(reward),
    show_quota_on_button: o.show_quota_on_button !== false,
    exhausted_modal_title: trimDialText(
      o.exhausted_modal_title,
      d.exhausted_modal_title,
      64,
    ),
    exhausted_modal_body: trimDialText(
      o.exhausted_modal_body,
      d.exhausted_modal_body,
      512,
    ),
  };
}
